(function () {
  'use strict';

  /* @ngdoc object
   * @name fuel
   * @description
   *
   */
  angular
    .module('fuel', [
      'ui.router'
    ]);
}());
